import React from "react";

const ProductSkeleton = () => {
    return (
        <div className="animate-pulse flex flex-col md:flex-row gap-6 p-4">
            {/* Image Skeleton */}
            <div className="bg-[#F0F0F0] w-full md:w-1/3 h-64 md:h-[420px] rounded-lg"></div>

            {/* Content Skeleton */}
            <div className="flex flex-col flex-grow space-y-4">
                {/* Title Placeholder */}
                <div className="bg-[#F0F0F0] h-6 w-3/4 rounded"></div>

                {/* Subtitle Placeholder */}
                <div className="bg-[#F0F0F0] h-4 w-1/2 rounded"></div>

                {/* Description Placeholder */}
                <div className="bg-[#F0F0F0] h-4 w-full rounded"></div>
                <div className="bg-[#F0F0F0] h-4 w-5/6 rounded"></div>
                <div className="bg-[#F0F0F0] h-4 w-4/6 rounded"></div>

                {/* Button Placeholder */}
                <div className="bg-[#F0F0F0] h-10 w-32 rounded mt-6"></div>
            </div>
        </div>
    );
};

export default ProductSkeleton;
